import { FC } from 'react';
import { ConfirmationProps } from '@servicetitan/confirm';
import { BodyText, Dialog } from '@servicetitan/design-system';
import { KeyName } from '../../../common/enums/key-name';
import { useKeyDown } from '../../../common/hooks/use-key-down';

export const ConfirmDeleteDialog: FC<ConfirmationProps> = ({ onConfirm, onCancel }) => {
    useKeyDown(KeyName.Enter, onConfirm);
    useKeyDown(KeyName.Escape, onCancel);

    return (
        <Dialog
            open
            negative
            title="Delete Partition?"
            primaryActionName="Delete"
            secondaryActionName="Cancel"
            onPrimaryActionClick={onConfirm}
            onSecondaryActionClick={onCancel}
        >
            <BodyText>It can’t be undone and will permanently remove all associated data.</BodyText>
        </Dialog>
    );
};
